import { logError } from './errorLogging';

export function initErrorReporting() {
  window.addEventListener('unhandledrejection', (event) => {
    logError(event.reason);
  });
  
  window.addEventListener('error', (event) => {
    logError(event.error);
  });
}